import { gql } from '@apollo/client';
/**
 * @const ApproveDealMutation
 * @since 1.0.0
 */
export const ApproveDealMutation = gql `
  mutation ApproveDealMutation($input: ApproveDealInput!) {
    approveDeal(input: $input)
  }
`;
